"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var rxjs_1 = require("rxjs");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var GeolocationService = /** @class */ (function () {
    function GeolocationService(geolocationClient) {
        this.geolocationClient = geolocationClient;
    }
    GeolocationService.prototype.CitiesByPopulation = function (top, order) {
        if (order === void 0) { order = false; }
        if (MOSTPOPULARCITIES60 && top == 60) {
            if (order) {
                MOSTPOPULARCITIES60.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    else
                        return 1;
                });
                return rxjs_1.of(MOSTPOPULARCITIES60);
            }
            else
                return rxjs_1.of(MOSTPOPULARCITIES60);
        }
        else {
            return this.geolocationClient.cityMostPopulation(top);
        }
    };
    GeolocationService.prototype.getSubregionDefault = function (ip) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var sub = _this.geolocationClient.getNearestCity(ip).subscribe(function (r) {
                rs(r);
                sub.unsubscribe();
            });
        });
    };
    GeolocationService.prototype.GetSubregionByIP = function (ip) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var sub = _this.geolocationClient.getSubregionByIP(ip).subscribe(function (r) {
                rs(r);
                sub.unsubscribe();
            });
        });
    };
    GeolocationService.prototype.GetSubregionByZIP = function (zip) {
        var _this = this;
        return new Promise(function (rs, rj) {
            var sub = _this.geolocationClient.getSubregionByZip(zip).subscribe(function (r) {
                rs(r);
                sub.unsubscribe();
            });
        });
    };
    GeolocationService.prototype.GetRegion = function (regionId) {
        return this.geolocationClient.getRegion(regionId).toPromise();
    };
    GeolocationService.prototype.GetSubregionObservable = function (subregionId) {
        return this.geolocationClient.getSubregion(subregionId);
    };
    GeolocationService.prototype.GetSubregion = function (subregionId) {
        return this.geolocationClient.getSubregion(subregionId).toPromise();
    };
    GeolocationService.prototype.GetGeolocationSearchModel = function () {
        return this.geolocationClient.getGeolocationSearchModel();
    };
    GeolocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GeolocationService_Factory() { return new GeolocationService(i0.ɵɵinject(i1.GeolocationClient)); }, token: GeolocationService, providedIn: "root" });
    return GeolocationService;
}());
exports.GeolocationService = GeolocationService;
